import React, { useEffect, useState } from 'react';
import { apiCall, getCategoryColor, getPatientTypeRoleByAcronym } from '../../utils';
import Swal from 'sweetalert2';

const DoctorViewPatientMedicalRecord = ({
  patientId,
  agendaId,
  businessPlans,
  businessServices
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [patientData, setPatientData] = useState(null);

  const [patientQuestionary, setPatientQuestionary] = useState(null);
  const [patientTreatment, setPatientTreatment] = useState(null);
  const [patientViewReports, setPatientViewReports] = useState(false);

  useEffect(() => {
    fetchPatientData();

    return () => {
      setIsLoading(false);
      setPatientData(null);
      setPatientQuestionary(null);
      setPatientTreatment(null);
      setPatientViewReports(false);
    }
  }, []);

  useEffect(() => {
    if (patientQuestionary) {
      //console.log('patientQuestionary', patientQuestionary);
    }
  }, [patientQuestionary]);

  const fetchPatientData = async () => {
    if (!patientId)
      return null;
    setIsLoading(true);
    apiCall({
      method: 'GET',
      endpoint: 'api/v1/doctor/schedule',
      data: {
        patient_id: patientId,
        agenda_id: agendaId
      },
      successCallback: function(res) {
        setIsLoading(false);
        if (res.error) {
          window.toast({
            error: res.error,
            text: res.message
          })
        } else {
          setPatientData(res.data);
        }
      },
      errorCallback: function(res) {
        setIsLoading(false);
      }
    });
  }

  const savePatientReport = (e) => {
    e.preventDefault();
    Swal.fire({
      title: 'Salvar Relato',
      text: 'Deseja salvar o relato do paciente?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.isConfirmed) {
        let form = document.getElementById('questionaryForm');
        let formData = new FormData(form);

        let data = {
          patient_id: patientId,
          agenda_id: agendaId,
          questions: []
        }

        for (let pair of formData.entries()) {
          let question = pair[0].split('-')[1];
          let questionText = document.getElementById(`question-text-${question}`).innerText;
          let answers = data.questions.find((q) => q.question === question);
          if (pair[1] === '') {
            continue;
          }
          if (!answers) {
            answers = {
              question: questionText,
              questionId: question,
              answer: []
            }
            data.questions.push(answers);
            answers.answer.push(pair[1]);
          } else {
            answers.answer.push(pair[1]);
          }
        }

        setIsLoading(true);
        apiCall({
          method: 'POST',
          endpoint: 'api/v1/doctor/schedule/report',
          data: data,
          successCallback: function(res) {
            setIsLoading(false);
            window.toast({
              error: res.error,
              text: res.message
            })
            if (!res.error) {
              fetchPatientData();
              setPatientQuestionary(null);
              setPatientTreatment(null);
              // reset form
              form.reset();
            }
          },
          errorCallback: function(res) {
            setIsLoading(false);
          }
        });
      }
    });
  }

  const endPatientService = (e, type = 'PR') => {
    e.preventDefault();
    Swal.fire({
      title: 'Confirmar Encerramento',
      text: 'Tem certeza que deseja encerrar o atendimento?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6'
    }).then((result) => {
      if (result.isConfirmed) {
        let form = null;
        if (type === 'PN') {
          form = document.getElementById('treatmentFormPN');
        } else {
          form = document.getElementById('treatmentForm');
        }
        let formData = new FormData(form);

        formData.append('patient_id', patientId);
        formData.append('agenda_id', agendaId);

        setIsLoading(true);
        apiCall({
          method: 'POST',
          endpoint: 'api/v1/doctor/schedule/end',
          data: formData,
          processData: false,
          contentType: false,
          successCallback: function(res) {
            setIsLoading(false);
            window.toast({
              error: res.error,
              text: res.message
            })
            if (!res.error) {
              fetchPatientData();
              setPatientQuestionary(null);
              setPatientTreatment(null);
              // reset forms
              form.reset();
            }
          },
          errorCallback: function(res) {
            setIsLoading(false);
          }
        });
      }
    });
  }

  const startPatientService = (e) => {
    e.preventDefault();
    Swal.fire({
      title: 'Confirmar Início',
      text: 'Deseja iniciar o atendimento?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33'
    }).then((result) => {
      if (result.isConfirmed) {
        setIsLoading(true);
        apiCall({
          method: 'POST',
          endpoint: 'api/v1/doctor/schedule/start',
          data: {
            patient_id: patientId,
            agenda_id: agendaId
          },
          successCallback: function(res) {
            setIsLoading(false);
            window.toast({
              error: res.error,
              text: res.message
            })
            if (!res.error) {
              fetchPatientData();
              setPatientQuestionary(null);
              setPatientTreatment(null);
            }
          },
          errorCallback: function(res) {
            setIsLoading(false);
          }
        });
      }
    });
  }

  const findReport = patientData ? patientData.PatientReports.find((obj) => obj.AGENDA_ID === agendaId) : 0;
  const findReportLength = findReport ? findReport.length : 0;
  const findQuestionaryLength = patientData ? patientData.Questionary.Questions.length : 0;

  return (
    <>
      {isLoading && (
        <div className="text-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Carregando...</span>
          </div>
        </div>
      )}
      {isLoading === false && (
        <div className="row">
          <div className="col-md-3">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Paciente</h5>
                <p className="card-text">
                  {patientData && patientData.ScheduleInfo.CLIENTE_DADOS.split("|")[0]}
                </p>
                <h5 className="card-title">Agendamento</h5>
                <p className="card-text">
                  {patientData && patientData.ScheduleInfo.DATA_INICIO + ' ' + patientData.ScheduleInfo.HORA_INICIO}
                </p>
                <h5 className="card-title">Categoria</h5>
                <p className="card-text">
                  {patientData && (
                    <button type="button" className="btn btn-sm" style={{background:getCategoryColor(patientData.ScheduleInfo.CATEGORIA), color: '#fff'}}>{patientData.ScheduleInfo.CATEGORIA}</button>
                  )}
                </p>
                <h5 className="card-title">Ações disponíveis</h5>
                {patientData && patientData.ScheduleInfo.CATEGORIA === 'Presente' && (<button className="btn btn-primary mb-3" onClick={(e) => { startPatientService(e); }}>Iniciar atendimento</button>)}
                {patientData && patientData.ScheduleInfo.CATEGORIA === 'Em Atendimento' && getPatientTypeRoleByAcronym(patientData.ScheduleInfo.TIPO_PACIENTE) !== 'PACIENTE_NOVO' && (<button className="btn btn-primary mb-3" onClick={
                  (e) => {
                    if (patientQuestionary) {
                      Swal.fire({
                        title: 'Confirmar Finalização',
                        text: 'Tem certeza que deseja finalizar o atendimento?',
                        icon: 'question',
                        showCancelButton: true,
                        confirmButtonText: 'Sim',
                        cancelButtonText: 'Não',
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33'
                      }).then((result) => {
                        if (result.isConfirmed) {
                          setPatientQuestionary(false);
                          setPatientTreatment(true);
                          setPatientViewReports(false);
                        }
                      });
                    } else {
                      setPatientTreatment(true);
                      setPatientViewReports(false);
                    }
                  }
                }><i className="fas fa-stop-circle"></i> Finalizar atendimento</button>)}

                {patientData && (patientData.ScheduleInfo.CATEGORIA === 'Em Atendimento') && getPatientTypeRoleByAcronym(patientData.ScheduleInfo.TIPO_PACIENTE) === 'PACIENTE_NOVO' && findQuestionaryLength > 0 && !patientTreatment && findReportLength === 0 && (<button className="btn btn-info mb-3" disabled={patientTreatment} onClick={(e) => { 
                  if (patientQuestionary) {
                    Swal.fire({
                      title: 'Parar Questionário',
                      text: 'Deseja parar o questionário? As respostas não salvas serão perdidas.',
                      icon: 'question',
                      showCancelButton: true,
                      confirmButtonText: 'Sim',
                      cancelButtonText: 'Não'
                    }).then((result) => {
                      if (result.isConfirmed) {
                        setPatientQuestionary(!patientQuestionary);
                      }
                    });
                  } else {
                    setPatientQuestionary(!patientQuestionary); 
                  }
                  setPatientViewReports(false);
                  setPatientTreatment(false);
                }}>{patientQuestionary ? <i className="fas fa-stop-circle"></i> : <i className="fas fa-arrow-right"></i>}{patientQuestionary ? ' Parar' : ' Iniciar'} Relato Paciente</button>)}
                {/** Ver relatos */}
                {patientData && patientData.PatientReports.length > 0 && !patientQuestionary && (<button className="btn btn-primary mb-3" onClick={() => {
                  setPatientTreatment(false);
                  setPatientQuestionary(false);
                  setPatientViewReports(!patientViewReports);
                }}>{patientViewReports ? <i className="fas fa-eye-slash"></i> : <i className="fas fa-eye"></i>}{patientViewReports ? ' Esconder' : ' Ver'} Relatos</button>)}
                {patientData && (patientData.ScheduleInfo.CATEGORIA === 'Em Atendimento') && !patientQuestionary && getPatientTypeRoleByAcronym(patientData.ScheduleInfo.TIPO_PACIENTE) === 'PACIENTE_NOVO' && (<button className="btn btn-primary" onClick={(e) => {
                  if (patientQuestionary) {
                    Swal.fire({
                      title: 'Confirmar Parada',
                      text: 'Deseja parar o questionário? As respostas não salvas serão perdidas.',
                      icon: 'question',
                      showCancelButton: true,
                      confirmButtonText: 'Sim',
                      cancelButtonText: 'Não',
                      confirmButtonColor: '#3085d6',
                      cancelButtonColor: '#d33'
                    }).then((result) => {
                      if (result.isConfirmed) {
                        setPatientQuestionary(!patientQuestionary);
                        setPatientTreatment(!patientTreatment);
                        setPatientViewReports(false);
                      }
                    });
                  } else {
                    setPatientTreatment(!patientTreatment);
                    setPatientViewReports(false);
                  }
                }}>{patientTreatment ? <i className="fas fa-stop-circle"></i> : <i className="fas fa-arrow-right"></i>}{patientTreatment ? ' Parar encerramento' : ' Indicação/Encerrar atendimento'}</button>)}
              </div>
            </div>
          </div>

          <div className="col-md-9">
            {patientData && (patientData.ScheduleInfo.CATEGORIA === 'Presente') && (
              <div className="alert alert-warning" role="alert">
                <strong>Atenção!</strong> O paciente está presente na Clínica.<br />
                Inicie o atendimento para continuar.
              </div>
            )}
            {patientQuestionary && (
              <div className="card mb-3">
                <div className="card-body">
                  <h5 className="card-title">Relato Paciente</h5>
                  <form id="questionaryForm" onSubmit={(e) => { savePatientReport(e); }}>
                  <div className="card-text">
                    {patientData && patientData.Questionary.Questions.map((question, index) => {
                      return (
                        <div key={`question-${index + 1}`}>
                          <p><strong id={`question-text-${index + 1}`}>{question.PERGUNTA}</strong></p>
                          {question.Answers.map((answer, idx) => {
                            return (
                              <div key={`answer-${idx + 1}`}>
                                <input type={question.INPUT_TYPE.toLowerCase()} id={`answer-${index + 1}-${idx}`} name={`answer-${index + 1}`} value={answer.RESPOSTA} />
                                <label htmlFor={`answer-${index + 1}-${idx}`}>&nbsp;{answer.RESPOSTA}</label>
                              </div>
                            )
                          })}
                          <label htmlFor={`answer-${index + 1}`}>Outro:</label>
                          <textarea id={`answer-${index + 1}`} name={`answer-${index + 1}`} className="form-control"></textarea>
                          <hr className="divider" />
                        </div>
                      )
                    }
                  )}
                  </div>
                  <button type="submit" className="btn btn-primary"><i className="fas fa-save"></i> Salvar Relato</button>
                  </form>
                </div>
              </div>
            )}

            {patientTreatment && (
              <div className="card mb-3">
                <div className="card-body">
                  {patientData && getPatientTypeRoleByAcronym(patientData.ScheduleInfo.TIPO_PACIENTE) === 'PACIENTE_NOVO' && (
                    <>
                      <h5 className="card-title"><i className="fas fa-arrow-right"></i> Indicação/Encerrar atendimento</h5>
                      <form id="treatmentFormPN" encType="multipart/form-data" onSubmit={(e) => { endPatientService(e, 'PN'); }}>
                        <div className="mb-3">
                          <label htmlFor="indicacao_plano" className="form-label">Plano <span className="req">*</span></label>
                          <select id="indicacao_plano" name="indicacao_plano" className="form-select" defaultValue={``} required>
                            <option value="" disabled>Selecione um plano</option>
                            {businessPlans && businessPlans.map((plan, index) => {
                              return (
                                <option key={`plan-${index + 1}`} value={plan.ID}>{plan.DESCRICAO}</option>
                              )
                            })}
                          </select>
                        </div>
                        <div className="mb-3">
                          <label htmlFor="indicacao_servico" className="form-label">Serviços <span className="req">*</span></label>
                          <select id="indicacao_servico" name="indicacao_servico" className="form-select" defaultValue={``} required>
                            <option value="" disabled>Selecione um serviço</option>
                            {businessServices && businessServices.map((service, index) => {
                              if (service.ID !== 1 && service.ID !== 3) {
                                return (
                                  <option key={`service-${index + 1}`} value={service.ID}>{service.SERVICO}</option>
                                )
                              }
                            })}
                          </select>
                        </div>
                        <div className="mb-3">
                          <label htmlFor="observacao" className="form-label">Observação da sessão realizada hoje <span className="req">*</span></label>
                          <textarea id="observacao" name="observacao" className="form-control" maxLength={400} required></textarea>
                        </div>
                        {/*<div className="mb-3">
                          <label htmlFor="anexos" className="form-label">Anexos</label>
                          <input type="file" id="anexos" name="anexos[]" className="form-control" multiple />
                        </div>*/}
                        <button type="submit" className="btn btn-primary">Salvar Indicação/Encerramento</button>
                      </form>
                    </>)}

                  {patientData && getPatientTypeRoleByAcronym(patientData.ScheduleInfo.TIPO_PACIENTE) !== 'PACIENTE_NOVO' && (
                    <>
                      <h5 className="card-title"><i className="fas fa-stop-circle"></i> Encerrar atendimento</h5>
                      <form id="treatmentForm" encType="multipart/form-data" onSubmit={(e) => { endPatientService(e); }}>
                        <div className="mb-3">
                          <label htmlFor="observacao" className="form-label">Observação da sessão realizada hoje <span className="req">*</span></label>
                          <textarea id="observacao" name="observacao" className="form-control" required></textarea>
                        </div>
                        {/*<div className="mb-3">
                          <label htmlFor="anexos" className="form-label">Anexos</label>
                          <input type="file" id="anexos" name="anexos[]" className="form-control" multiple />
                        </div>*/}
                        <button type="submit" className="btn btn-primary"><i className="fas fa-stop-circle"></i> Encerrar atendimento</button>
                      </form>
                    </>)}
                </div>
              </div>
            )}

            {patientData && !patientViewReports && patientData.PatientObsHistory.length > 0 && (
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title"><i className="fas fa-eye"></i> Observações atendimentos</h5>
                  <div className="card-text">
                    {patientData && patientData.PatientObsHistory.map((obs, index) => {
                      return (
                        <div key={`obs-${index + 1}`}>
                          <div>
                            <p className="mb-0">{obs.OBSERVACAO}</p>
                            <small>Atendimento em {obs.DATA_ATENDIMENTO}</small><br />
                            <small>Doutor(a) {obs.DOUTOR_NOME}</small>
                          </div>
                          <hr className="divider" />
                        </div>
                      )
                    })}
                  </div>
                </div>
              </div>
            )}

            {patientData && patientViewReports && patientData.PatientReports.length > 0 && (
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title"><i className="fas fa-file-alt"></i> Relato Paciente</h5>
                  <div className="card-text">
                    {patientData && patientData.PatientReports.map((report, index) => {
                      const perguntas = report.PERGUNTAS.split(' | ');
                      const respostas = report.RESPOSTAS.split(' | ');
                      
                      return (
                        <div key={`report-${index + 1}`}>
                          <div>
                            {perguntas.map((pergunta, idx) => (
                              <div key={`pergunta-${idx}`}>
                                <p className="mb-0"><strong>Pergunta: {pergunta}</strong></p>
                                <p className="mb-0">Resposta: {respostas[idx] || 'Não respondida'}</p>
                              </div>
                            ))}
                            <small>Atendimento em {report.DATA_RELATO}</small><br />
                            <small>Doutor(a) {report.DOUTOR_NOME}</small>
                          </div>
                          <hr className="divider" />
                        </div>
                      )
                    })}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  )
}

export default DoctorViewPatientMedicalRecord;